import { Switch, Route, useRouteMatch } from 'react-router-dom';
import LoadComponentWithRetry from '@/app/routes/LoadComponentWithRetry';

const ViewComponent = LoadComponentWithRetry(() => import('./ViewDashboardPage'));

const Routes = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={path} component={ViewComponent} />
    </Switch>
  );
};

export default Routes;
